import styled from 'styled-components';

export const PriceWrapper = styled.span<{ discount: boolean }>`
  ${({ discount, theme }) =>
    discount &&
    `
    text-decoration: line-through;
    color: ${theme.defaultColors.grey};
  `}
`;

export const DiscountWrapper = styled.span`
  color: ${({ theme }) => theme.defaultColors.black};
  margin-left: 0.6rem;
`;
